import { useState } from "react";

import { GlobeIcon, NewspaperIcon } from "lucide-react";

import { formatDate } from "simplydo/core/dates";
import { H3 } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";

import type { CompanyNewsItem } from "components/innointel/types";
import { FakeLink } from "components/lib/UI";

import {
  InfoBoxWidget,
  InfoBoxWidgetTitleArea,
  InfoContainer,
  InfoItem,
  KeyFactLink,
} from "../Styles";

type CompanyNewsProps = { news: CompanyNewsItem[] };

const CompanyNews = ({ news }: CompanyNewsProps) => {
  const [viewingMore, setViewingMore] = useState(false);

  if (!news.length) {
    return null;
  }

  return (
    <InfoBoxWidget $sectioned style={{ marginLeft: 0 }}>
      <InfoBoxWidgetTitleArea>
        <Icon icon={GlobeIcon} />
        <H3>News</H3>
        <span>{news.length} found</span>
      </InfoBoxWidgetTitleArea>
      <InfoContainer $wrapped>
        {news.slice(0, viewingMore ? 30 : 10).map((article, index) => (
          <InfoItem
            key={article._id ?? article.url ?? `${article.title}-${index}`}
            href={article.url}
          >
            <KeyFactLink
              title={article.title ?? "Untitled"}
              fact={
                article.postedAt
                  ? `Published: ${formatDate(article.postedAt, "yyyy-MM-dd HH:mm")}`
                  : "Published date unknown"
              }
              image={article.imageUrl}
              imageAltContent={<Icon icon={NewspaperIcon} size="large" />}
            />
          </InfoItem>
        ))}
      </InfoContainer>
      {news.length > 9 && (
        <div style={{ textAlign: "center" }}>
          <FakeLink onClick={() => setViewingMore(!viewingMore)} withBorder>
            View {viewingMore ? "fewer" : "more"} news
          </FakeLink>
        </div>
      )}
    </InfoBoxWidget>
  );
};

export default CompanyNews;
